export default __webpack_public_path__ + "static/media/new-action.75ebb3ca.svg";